import RichTextResolver from 'storyblok-js-client/dist/rich-text-resolver.cjs';

import type { StoryblokComponent } from 'storyblok-js-client';

type Node = {
  attrs: {
    href: string;
    anchor?: string;
    src: string;
    alt: string;
    title: string;
    level: string;
    linktype: string;
    body: StoryblokComponent<string>[];
  };
};

const isEmailLinkType = (type: string): boolean => type === 'email';

const CustomizedRteSchema = {
  nodes: {
    horizontal_rule() {
      return {
        singleTag: 'hr',
      };
    },
    blockquote() {
      return {
        tag: 'blockquote',
      };
    },
    bullet_list() {
      return {
        tag: 'ul',
      };
    },
    code_block(node: Node) {
      return {
        tag: [
          'pre',
          {
            tag: 'code',
            attrs: node.attrs,
          },
        ],
      };
    },
    hard_break() {
      return {
        singleTag: 'br',
      };
    },
    heading(node: Node) {
      return {
        tag: `h${node.attrs.level}`,
      };
    },
    list_item() {
      return {
        tag: 'li',
      };
    },
    ordered_list() {
      return {
        tag: 'ol',
      };
    },
    paragraph() {
      return {
        tag: 'p',
      };
    },
  },
  marks: {
    bold() {
      return {
        tag: 'b',
      };
    },
    strike() {
      return {
        tag: 'strike',
      };
    },
    underline() {
      return {
        tag: 'u',
      };
    },
    strong() {
      return {
        tag: 'strong',
      };
    },
    code() {
      return {
        tag: 'code',
      };
    },
    italic() {
      return {
        tag: 'i',
      };
    },
    link(node: Node) {
      const attrs = { ...node.attrs };
      const { linktype = 'url' } = node.attrs;

      if (isEmailLinkType(linktype)) {
        attrs.href = `mailto:${attrs.href}`;
      }

      if (attrs.anchor) {
        attrs.href = `${attrs.href}#${attrs.anchor}`;
        delete attrs.anchor;
      }

      return {
        tag: [
          {
            tag: 'a',
            attrs: attrs,
          },
        ],
      };
    },
    styled(node: Node) {
      return {
        tag: [
          {
            tag: 'span',
            attrs: node.attrs,
          },
        ],
      };
    },
  },
};

export const richTextResolver = new RichTextResolver(CustomizedRteSchema);
